import * as CONFIGS from "@/statics/configs.js";

const NODE12 = {
  NAME: "TS2C",
  INPUT1: {
    NAME: "NODE12_INPUT1_NAME",
    TYPE: "zeroContact",
    ICON: "switch",
    PARAMETER_ID: 0x8020,
  },
  INPUT2: {
    NAME: "NODE12_INPUT2_NAME",
    TYPE: "zeroContact",
    ICON: "switch",
    PARAMETER_ID: 0x8021,
  },
  AUTOENABLE1: {
    NAME: "NODE12_AUTOENABLE1_NAME",
    PARAMETER_ID: 0xE030,
  },
  AUTOENABLE2: {
    NAME: "NODE12_AUTOENABLE2_NAME",
    PARAMETER_ID: 0xE031,
  },
  OUTPUT1: {
    NAME: "NODE12_OUTPUT1_NAME",
    TYPE: "RelaySSR2A",
    ICON: "lamp",
    PARAMETER_ID: 0xe010,
  },
  OUTPUT2: {
    NAME: "NODE12_OUTPUT2_NAME",
    TYPE: "RelaySSR2A",
    ICON: "lamp",
    PARAMETER_ID: 0xe011,
  },
  LEDSTATE1: {
    NAME: "NODE12_LEDSTATE1_NAME",
    TYPE: "LED",
    ICON: "lamp",
    PARAMETER_ID: 0xE120,
  },
  LEDSTATE2: {
    NAME: "NODE12_LEDSTATE2_NAME",
    TYPE: "LED",
    ICON: "lamp",
    PARAMETER_ID: 0xE121,
  },
  TEMPERATURE: {
    NAME: "NODE12_TEMPERATURE_NAME",
    TYPE: "internalTemperature",
    ICON: "temperature",
    PARAMETER_ID: 0x8101,
  },
  NOTIFY_HUB: {
    PARAMETER_ID: 0x6100,
  },
  RELAY1_INIT: {
    PARAMETER_ID: 0xe110,
  },
  RELAY2_INIT: {
    PARAMETER_ID: 0xe111,
  },
  RELAY3_INIT: {
    PARAMETER_ID: 0xe112,
  },
  LORA_RSSI: {
    PARAMETER_ID: 0x8102,
  },
  LORA_SNR: {
    PARAMETER_ID: 0x8103,
  },
};
NODE12.DEFAULT_INSTRUCTIONS = [
  [
    {
      eventToWatch: {
        parameterId: NODE12.INPUT1.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE12.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 0,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE12.INPUT2.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE12.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 0,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
  ],
];

export default NODE12;
